import { DOWNLOAD_ORDER_CONFIRMATION as FEATURE_PREFIX } from 'featurePrefix.ids'

const DOWNLOAD_ORDER_MODAL = 'Download-Order-Modal'

export const DownloadOrderIds = {
  DownloadOrderPDF: `${FEATURE_PREFIX}__${DOWNLOAD_ORDER_MODAL}__PDF-Selector`,
  DownloadOrderExcel: `${FEATURE_PREFIX}__${DOWNLOAD_ORDER_MODAL}__Excel-Selector`,
  DownloadOrderRaw: `${FEATURE_PREFIX}__${DOWNLOAD_ORDER_MODAL}__Raw-Order-Data-Selector`,
  DownloadOrderButton: `${FEATURE_PREFIX}__${DOWNLOAD_ORDER_MODAL}__Download-Button`,
}
